import { forwardRef } from "react";
import PropTypes from "prop-types";
import clsx from "clsx";
import LoadingSpinner from "./loading-spinner";
import RoundLoadingSpinner from "./round-loading-spinner";

const Button = forwardRef(function Button(
  { children, type = "button", className, loading, disabled, icon, ...rest },
  ref,
) {
  return (
    <button
      {...rest}
      ref={ref}
      type={type}
      disabled={disabled || loading}
      className={clsx(
        className ?? [
          "min-h-10 font-semibold rounded-full",
          icon
            ? "w-10 h-10 flex justify-center items-center"
            : "w-full px-3 py-2 bg-green-500 dark:bg-lime-500 text-sm",
          disabled && "opacity-60 cursor-not-allowed",
          loading &&
            "flex justify-center items-center opacity-50 cursor-progress",
        ],
      )}
    >
      {loading ? (
        <div className="flex justify-center items-center w-6 h-6">
          {icon ? <RoundLoadingSpinner /> : <LoadingSpinner />}
        </div>
      ) : (
        <div className="dark:text-green-500 text-white">{children}</div>
      )}
    </button>
  );
});

Button.propTypes = {
  children: PropTypes.node,
  type: PropTypes.oneOf(["button", "submit"]),
  className: PropTypes.string,
  loading: PropTypes.bool,
  disabled: PropTypes.bool,
  icon: PropTypes.bool,
};

export default Button;
